import React from "react";
import TransactionItem from "./TransactionItem";
import styled from "@emotion/styled";
import { Transaction } from "../types";

const StyledRecentTransactions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-height: 500px;
  min-height: 200px;
  overflow-y: auto;
  border-radius: 8px;
  background: #fff;
  h3 {
    font-family: "Rethink-Sans-Bold", sans-serif;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    color: #000;
    padding: 10px 12px 0px 12px;
    @media (min-width: 768px) {
      font-size: 20px;
    }
  }
  p {
    font-family: "Rethink-Sans-Regular", sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    color: #000;
    padding: 10px 12px 0px 12px;
    @media (min-width: 768px) {
      font-size: 16px;
    }
  }
`;

interface RecentTransactionsProps {
  transactions: Transaction[];
  isUserTransaction: boolean;
  isLoading: boolean;
}

const RecentTransactions: React.FC<RecentTransactionsProps> = ({
  transactions,
  isUserTransaction,
  isLoading,
}) => {
  if (isLoading)
    return (
      <StyledRecentTransactions>
        <h3>Recent Transactions</h3>
        <p>Loading...</p>
      </StyledRecentTransactions>
    );

  return (
    <StyledRecentTransactions>
      <h3>Recent Transactions</h3>
      {transactions.length === 0 && isUserTransaction && (
        <p>This diner has not made any transactions at this location yet.</p>
      )}
      {transactions.length > 0 &&
        transactions.map((tx) => {
          return (
            <TransactionItem
              key={tx.id}
              transaction={tx}
              isUserTransaction={isUserTransaction}
            />
          );
        })}
    </StyledRecentTransactions>
  );
};

export default RecentTransactions;
